// eslint-disable-next-line import/no-unresolved
import { DEFAULT_LIST_LENGTH } from '@/shared/constants/'
import { isNonEmptyText } from '@hw-core/utils'

const extractInput = queryParams => {
	const { q } = queryParams
	return q
}

const isListLenLimitExceeded = _list => _list.length >= DEFAULT_LIST_LENGTH

const initList = (input, _originalList) => (isNonEmptyText(input) ? [] : _originalList)

export { extractInput, isListLenLimitExceeded, initList }
